module.exports = "/_next/static/images/google-drive-a7314bb85ae72947728c3615eee258cf.svg";